export default "__VITE_ASSET__61343cb6__"